import React from 'react'
import PropTypes from "prop-types"
import moment from 'moment'
import { DateTimePicker } from 'react-widgets'

import {  Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

import { str2date, date2str } from '../../lib/Tools.js'
import { getTripCode } from '../../lib/TripTools'

import { getText } from '../lib/text'


const Factura = ({trip, editTrip}) => (
  <Form inline>
    <FormGroup>
      <ControlLabel style={{ marginRight: 5 }}>{getText("Número de factura")}:</ControlLabel>
      <FormControl
        style={{ width: 150 }}
        value={trip.receiptNumber || ""}
        onChange={evt => editTrip({ receiptNumber: evt.target.value })}
      />
      {" / "}
      <FormControl
        style={{ width: 80 }}
        type="number"
        value={trip.receiptYear || (new Date()).getFullYear()}
        onChange={evt => editTrip({ receiptYear: evt.target.value })}
      />
    </FormGroup>
    <br />
    <FormGroup style={{ marginTop: 10 }}>
      <ControlLabel style={{ marginRight: 5 }}>{getText("Fecha de factura")}:</ControlLabel>
      <DateTimePicker
        calendar
        style={{ display: "inline-block", width: 160 }}
        time={false}
        format="YYYY/MM/DD"
        value={trip.receiptDate ? str2date(trip.receiptDate) : null}
        defaultCurrentDate={str2date(trip.receiptDate || moment().format("YYYY/MM/DD"))}
        onChange={d => editTrip({ receiptDate: date2str(d)}) }
      />
    </FormGroup>
    <br />
    <FormGroup style={{ marginTop: 10 }}>
      <ControlLabel style={{ marginRight: 5 }}>{getText("Facturación")}:</ControlLabel>
      <FormControl
        style={{ width: 150 }}
        value={trip.receiptValue || ""}
        onChange={evt => editTrip({ receiptValue: evt.target.value })}
      />
    </FormGroup>
    <br />
    <br />
    { trip.name && (<span><strong>Nombre: </strong>{`${trip.name}`}</span>) }
    <br />
    <br />
    { trip.realName && (<span><strong>Nombre (pinyin): </strong>{`${trip.realName}`}</span>) }
    <br />
    <br />
    { trip.wechat && (<span><strong>WeChat: </strong>{`${trip.wechat}`}</span>) }
    <br />
    <br />
    <span><strong>Código: </strong>{getTripCode(trip)}</span>
  </Form>
)

Factura.propTypes = {
  trip: PropTypes.object.isRequired,
  editTrip: PropTypes.func.isRequired
}

export default Factura
